import React from "react";

const Spinner = () => (
    <div className="flex justify-center items-center loading-spinner">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-yellow-600 border-t-transparent" />
    </div> 
);

export default Spinner;
